import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.ROUTER_BASE,
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    {
      path: '/',
      redirect: '/24qzwhzb'
    },
    {
      path: '/24qzwhzb',
      name: '24qzwhzb',
      component: () => import('@/views/pages/index'),
      meta: {
        pageTitle: '首页'
      }
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('@/views/pages/news/index'),
      meta: {
        pageTitle: '活动快讯'
      }
    },
    {
      path: '/exhibition',
      name: 'exhibition',
      component: () => import('@/views/pages/news/exhibition'),
      meta: {
        pageTitle: '观·展览'
      }
    },
    {
      path: '/lose',
      name: 'lose',
      component: () => import('@/views/pages/news/lose'),
      meta: {
        pageTitle: '赏·非遗'
      }
    },
    {
      path: '/cultural/:type',
      name: 'cultural',
      component: () => import('@/views/pages/news/cultural'),
      meta: {
        pageTitle: '游·陕西'
      }
    },
  
    {
      path: '/newsDetail/:id',
      component: () => import('@/views/pages/news/detail'),
      name: 'newsDetail',
      meta: { pageTitle: '资讯详情', icon: 'app', noCache: true, }
    },
    {
      path: '/picshow',
      name: 'picshow',
      component: () => import('@/views/pages/picshow'),
      meta: {
        pageTitle: '作品评选',
        keepAlive: true
      }
    },

    {
      path: '/dnkcwDetail/:ocCode/:type',
      name: 'dnkcwDetail',
      component: () => import('@/views/pages/pic_detail/dnkcw'),
      meta: {
        pageTitle: '作品评选',
      }
    },
    {
      path: '/pic_detail/:ocCode/:sortIndex/:teamCode/:ocName?/:searchSort',
      name: 'pic_detail',
      component: () => import('@/views/pages/pic_detail/index'),
      meta: {
        pageTitle: '视频详情'
      }
    },
    {
      path: '/img_detail/:ocCode/:sortIndex/:teamCode/:ocName?/:searchSort',
      name: 'img_detail',
      component: () =>
        import('@/views/pages/img_detail/index'),
      meta: {
        pageTitle: '图片详情'
      }
    },
    {
      path: '/monselect/:type',
      name: 'monselect',
      component: () => import('@/views/pages/monselect'),
      meta: {
        pageTitle: '精彩瞬间',
       
      }
    },
    {
      path: '/artmap',
      name: 'artmap',
      component: () => import('@/views/pages/history/artmap'),
      meta: {
        pageTitle: '活动地图',
      }
    },
    {
      path: '/login',
      component: () => import('@/views/login/login'),
      name: 'login',
      meta: { pageTitle: '登录页', icon: 'app', noCache: true }
    },
    // -------------------------------后台--资讯-----------------------------
    {
      path: '/newslist',
      component: () => import('@/views/newslist/news'),
      name: 'newslist',
      meta: { pageTitle: '活动快讯', icon: 'app', noCache: true }
    },
    {
      path: '/addNews',
      component: () => import('@/views/newslist/add'),
      name: 'addNews',
      meta: { pageTitle: '新增', icon: 'app', noCache: true, activeMenu: '/newslist' }
    },
    {
      path: '/editNews/:id',
      component: () => import('@/views/newslist/edit'),
      name: 'editNews',
      meta: { pageTitle: '新增', icon: 'app', noCache: true, activeMenu: '/newslist' }
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js